import React from "react";
import Select from "react-select";
import InputText from "../../../common/Input/InputText";
import styles from "../editLabReport.module.scss";

const options = [
  { label: "Positive", value: "Positive" },
  { label: "Negative", value: "Negative" },
  { label: "Weak Reactive", value: "Weak Reactive" },
];

const DengueProfile = ({ profile, testMap, handleTestProfileChange }) => {

  const renderField = (item, index) => {
    const testData = testMap.get(item._id) || {};

    return (
      <div className={styles.testAndProfileWrapper} key={index}>
        
        <div className={styles["inputWrapper"]}>
          <InputText
            value={item?.testName}
            label="Test Name"
            readOnly
          />
        </div>

        <div className={styles["inputWrapper"]}>
          <div className="form-group">
            <label className="col-form-label">Result:</label>

            <Select
              placeholder="Choose"
              value={
                testData.value
                  ? { label: testData.value, value: testData.value }
                  : null
              }
              onChange={(e) =>
                handleTestProfileChange(
                  e,
                  "value",
                  profile._id,
                  item._id
                )
              }
              options={options}
            />
          </div>
        </div>

      </div>
    );
  };

  return (
    <>
      {profile?.tests?.map((item, index) =>
        renderField(item, index)
      )}
    </>
  );
};

export default DengueProfile;